import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ROLES } from "src/constants";
import ConnectionService from "src/_services/ConnectionService";

export const getAcceptedConnections = createAsyncThunk(
    'connectin/getAcceptedConnections',
    async (_, { getState }) => {
        let connections = []
        let { role, merchant } = getState().entities.profile.profile
        const response = await ConnectionService.getAcceptedConnections();
        let payload = response.data.body
        connections = payload.map(connection => {
            return {
                connectionId: connection.id,
                priceType: connection.priceType,
                ...connection[(role === ROLES.shippingCompany || merchant?.role === ROLES.shippingCompany) ? "merchant" : "shippingCompany"].id
            }
        })

        return connections;
    }
);

const slice = createSlice({
    name: "connections",
    initialState: {
        connections: [],
        connectionsLoading: true,
    },
    reducers: {
        setLoading: (state, action) => {
            state.connectionsLoading = action.payload
        },
    },
    extraReducers: {
        [getAcceptedConnections.pending]: (state) => {
            state.connectionsLoading = true
        },
        [getAcceptedConnections.fulfilled]: (state, { payload }) => {
            state.connections = [...payload]
            state.connectionsLoading = false
        },
        [getAcceptedConnections.rejected]: (state) => {
            state.connectionsLoading = false
        },
    },
});


export const {
    setConnectionsLoading
} = slice.actions;



export default slice.reducer;
